import React, { FunctionComponent } from 'react';
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Navigation } from '../Navigation';
import styles from '../Layout/layout.module.scss';

interface LayoutInterface {
    children: React.ReactNode;
    footer?: boolean;
    header?: boolean;
    showNavOptions: boolean;
    showCurrentUserDetails: boolean;
}

const Template: FunctionComponent<LayoutInterface> = ({
    children,
    footer = false,
    header = true,
    showNavOptions = true,
    showCurrentUserDetails = true
}) => {
    return (
        <div className={`${styles.layout} ${header ? styles.header : 'noheader'}`}>
            <HelmetProvider>
                <Helmet>
                    <meta name="facebook-domain-verification" content="ofyc26w1w2mcz9pe7e5qzgbj8cb39r" />
                </Helmet>
            </HelmetProvider>
            {header && (
                <Navigation
                    showNavOptions={showNavOptions}
                    showCurrentUserDetails={showCurrentUserDetails}
                />
            )}
            <div className={styles.layoutInner}>{children}</div>
            {/* {footer && <Footer />} */}
        </div>
    );
};

export default Template;
